<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <div>
        <runEnvironment-left ref='environmentLeft' @getSelectItem='getSelectItem'></runEnvironment-left>
      </div>
    </template>
    <template v-slot:right_view>
      <!--{{selectEnvironmentName}}-->
      <div id="BSDevice" style="display: none">
        <BSDeviceList></BSDeviceList>
      </div>
      <div id="DP">
        <RuningEnviromentListPage></RuningEnviromentListPage>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import RunEnvironmentLeft from '@/components/deploymentManagement/runningEnvironment/RunEnvironmentLeft';
import BSDeviceList from '../../../components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/BSDeviceList';
import RuningEnviromentListPage from './runingEnviromentListPage';

export default {
  name: "run-environment",
  components: {
    BasicLayout,
    RunEnvironmentLeft,
    BSDeviceList,
    RuningEnviromentListPage
  },
  props: {},
  computed: {
    crumb() {
      return `运行环境/${this.selectEnvironmentName}`;
    }
  },
  data() {
    return {
      left: {
        show: true,
        name: '运行环境',
      },
      middle: {
        show: false,
        name: 'mo'
      },
      right: {
        show: true,
        crumb: `运行环境/POC-DP服务`,
      },
      selectEnvironmentId: '',
      selectEnvironmentName: '',
    }
  },

  methods: {
    getSelectItem(id, name) {
      this.selectEnvironmentId = id;
      this.selectEnvironmentName = name;
      if (id === 'list-1') {
        document.getElementById("BSDevice").style.display = 'none';
        document.getElementById("DP").style.display = 'block';

      } else if (id === 'list-3') {
        document.getElementById("BSDevice").style.display = 'block';
        document.getElementById("DP").style.display = 'none';
      }
      this.right.crumb = this.crumb;
      console.log('BSMain 选中环境:', id, name);
    },
  }
};
</script>
